export const TOGGLE_DROPDOWN = "TOGGLE_DROPDOWN"
export const NEW_ITEM = "NEW_ITEM"
export const REMOVE_ITEM = "REMOVE_ITEM"
export const CLEAR_CART_ITEM = "CLEAR_CART_ITEM"